"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponListRequest = void 0;
var CouponListRequest = /** @class */ (function () {
    function CouponListRequest() {
    }
    return CouponListRequest;
}());
exports.CouponListRequest = CouponListRequest;
//# sourceMappingURL=couponList.request.js.map